import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, FormGroup, FormControl } from 'react-bootstrap';
import authHeader from '../services/AuthHeader';
import SimpleReactValidator from 'simple-react-validator';

const EditPartyModal = (props) => {
  let initValue = {
    ballotCandidatePartyName: '',
  };

  const [user, setUser] = useState(initValue);
  const [hasChanged, setHasChanged] = useState(false);
  const [ballotCandidatePartyName, setBallotCandidatePartyName] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({ className: 'text-danger' })
  );
  const [showSubmit, setShowSubmit] = useState(true);
  let allValid = simpleValidator.current.allValid();

  /* Set candidate party */
  useEffect(() => {
    setUser({
      ballotCandidatePartyName: props.user.ballotCandidatePartyName,
    });
    setBallotCandidatePartyName(props.user.ballotCandidatePartyName);
  }, [props.user]);

  useEffect(() => {
    if (allValid) {
      setShowSubmit(false);
    } else {
      setShowSubmit(true);
    }
  }, [allValid]);

  const submitHandler = (e) => {
    e.preventDefault();

    async function doAction() {
      if (hasChanged === true) {
        /*put request when mode == "EDIT"*/
        if (props.mode === 'EDIT') {
          axios
            .put(
              process.env.REACT_APP_API_BASE +
                'party/' +
                props.user.ballotCandidatePartyId,
              user,
              { headers: authHeader() }
            )
            .then((res) => props.setRerender(true));
        }
        /*post request when mode == "ADD"*/

        if (props.mode === 'ADD') {
          axios
            .post(process.env.REACT_APP_API_BASE + 'party/', user, {
              headers: authHeader(),
            })
            .then((res) => props.setRerender(true));
        }
      }

      setHasChanged(false);
      setUser(initValue);
      setBallotCandidatePartyName('');
    }
    doAction();
  };

  /* change party info */
  const handleChange = function (varName, e) {
    setHasChanged(true);
    const { value } = e.target;
    setUser((state) => ({ ...state, [varName]: value }));
  };

  /* submit form */
  const handleClick = function () {
    setHasChanged(true);
    setUser((state) => ({ ...state }));
    props.onHide();
  };

  /* go back without changes */
  const handleBack = function () {
    setBallotCandidatePartyName('');
    setUser(initValue);
    props.onHide();
  };

  let cBallotCandidatePartyName = user.ballotCandidatePartyName;

  const { setRerenderListings, ...modalProps } = props;
  return (
    <Modal
      {...modalProps}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Add/Edit Parties
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={submitHandler}>
          <FormGroup controlId='ballotCandidatePartyName'>
            <FormControl
              placeholder='Party Name'
              defaultValue={ballotCandidatePartyName}
              aria-label='Party name'
              onChange={(e) => handleChange('ballotCandidatePartyName', e)}
              autoComplete='off'
              name='ballotCandidatePartyName'
              onBlur={simpleValidator.current.showMessageFor(
                'ballotCandidatePartyName'
              )}
            />
            {simpleValidator.current.message(
              'ballotCandidatePartyName',
              cBallotCandidatePartyName,
              'alpha_space'
            )}
          </FormGroup>

          <Button
            className='btn btn-default'
            type='submit'
            onClick={handleClick}
            disabled={showSubmit}
          >
            Save
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleBack}>Back</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditPartyModal;
